import $ from 'jquery';

$(function() {
    $('.js-revieve-full-look').on('click', (e) => {
        e.preventDefault();
        Revieve.API.show();
        logEngagement(window.location.href, 'VTO', 'Open');
    });

    $(window).on('revieveAddToBag', (e, data) => {
        data.products.forEach((product) => {
            addProductWithData({
                productCode: product.id,
                size: 'all',
                sectionURL: data.sectionUrl,
                csrfHash: data.csrfHash,
                useReferrer: true,
                isPopup: false,
                hotlistQuickView: false,
                count: 1,
                closeWindowAfterAddingToCart: true,
            });

            if (typeof insertFacebookAddToCart === 'function') {
                insertFacebookAddToCart(null, product.id, product.price, 'all');
            }

            if (typeof addToCartReddit === 'function') {
                const cartItems = [{
                    productCode: product.id,
                    productName: product.name,
                    productCategory: 'Beauty'
                }];
                addToCartReddit(cartItems, product.price, product.id, product.name, product.category);
            }
            if(typeof spanglePixelAddToCart === 'function'){
                spanglePixelAddToCart(product.id, product.price, 1);
            }
        });
    });
});


// WEBPACK FOOTER //
// ./src/scripts/entry-points/landing/index.js